import { useApolloClient } from '@apollo/client';
import { useOnEsignCompleted, useToken } from 'components/guest/lib';
import {
  ContractDocument,
  ContractQuery,
  ContractQueryVariables,
  DocumentWithTokenQuery,
} from 'generated/graphql';
import { useNavigate } from 'react-router-dom';

type Document = DocumentWithTokenQuery['documentWithToken'];

export const useOnCompleted = (document: Document) => {
  const token = useToken();
  const navigate = useNavigate();
  const client = useApolloClient();

  const showConfirmationIfComplete = () => {
    const contractData = client.cache.readQuery<ContractQuery, ContractQueryVariables>({
      query: ContractDocument,
      variables: { token },
    });

    if (contractData && contractData.contract.documents) {
      const documents = contractData.contract.documents.edges.map(edge => edge.node!);

      if (!documents.some(({ status }) => status !== 'completed'))
        navigate('/guest/contract/confirmation', { state: { complete: true } });
    }
  };

  useOnEsignCompleted(() => {
    client.cache.modify({
      id: client.cache.identify(document),
      fields: { status: () => 'completed' },
    });

    showConfirmationIfComplete();
  });

  return showConfirmationIfComplete;
};
